export default {"src":"/_next/static/media/alta-bg-bl.359ce306.svg","height":372,"width":406};